// Common utils

// Gtags
export const triggerTagging = (eventName: string, page: string, value?: any) => {
  if (typeof window.gtag !== 'undefined') {
    if (value) {
      window.gtag('event', eventName, {
        page: page,
        value: value
      })
    }
    window.gtag('event', eventName, {
      page: page
    })
  }
}
